// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"552":"3601a748","672":"d6f868e0"}[chunkId] + ".chunk.css";
};